<template>
    <div class="bg-grey-lightest">
        <section id="heading" class="pt-12 pb-24">
            <!-- Header Nav -->
            <header-nav></header-nav>
        </section>
        <section class="py-12">
            <div class="max-w-sm mx-auto px-6">
                <div v-if="step == 'invitationDetails'">
                    <div class="rounded bg-white shadow relative -mt-24" v-if="invitation">
                        <button @click="goBack" class="text-grey hover:text-black text-xl absolute pin-t pin-r p-2 m-2">
                            <span class="icon"><i class="mdi mdi-close"></i></span>
                        </button>
                        <div class="p-4 md:p-6">
                            <div class="mb-4">
                                <div class="text-blue text-sm mb-1">{{ $t('When_') }}</div>
                                <div class="text-black font-semibold text-lg">{{ invitation.date | momentFormat('YYYY-MM-DD', $t('date_selector_format')) }} à {{ invitation.time | momentFormatTime($t('time_format')) }}</div>
                            </div>
                            <div class="mb-4 flex justify-between">
                                <div>
                                    <div class="text-blue text-sm mb-1">{{ $t('Who_will_treat_me_') }}</div>
                                    <div class="text-grey-darkest">{{ invitation.doctorFirstName + ' ' + invitation.doctorLastName }}</div>
                                    <div class="text-sm text-grey-darker">{{ $t('type_' + invitation.emergencyType) }}</div>
                                    <div class="text-green font-semibold text-sm mt-1 mb-2" v-if="invitation.isDoctorRegulated && (invitation.emergencyType !== 'OSTEOPATH' && invitation.emergencyType !== 'PSYCHOLOGIST')"><i class="mdi mdi-currency-eur"></i> {{ $t('Contracted_doctor') }}</div>
                                    <div class="text-red font-semibold text-sm mt-1 mb-2" v-if="!invitation.isDoctorRegulated && (invitation.emergencyType !== 'OSTEOPATH' && invitation.emergencyType !== 'PSYCHOLOGIST')"><i class="mdi mdi-currency-eur"></i> {{ $t('Contracted_doctor_negative') }}</div>
                                    <div v-if="invitation.isDoctorMemberOfOsteopathie" class=" tooltip text-green font-semibold text-sm mt-1 mb-2"><i class="mdi mdi-check-circle"></i>
                                    {{ $t('Member_of_Osteopathie') }}
                                    <span class="tooltip-text text-sm">{{$t('Oste_tooltip')}}</span>
                                    </div>
                                </div>
                                <div>
                                    <avatar :avatar="invitation.doctorAvatar" :name="invitation.doctorFirstName + ' ' + invitation.doctorLastName" class="w-10 h-10"></avatar>
                                </div>
                            </div>
                            <div class="flex">
                                <span class="text-sm md:text-base">{{ $t('type_' + invitation.emergencyType) }}</span>
                            </div>
                            <div>
                                <div class="text-blue text-sm mb-1">{{ $t('Where_have_I_to_go_') }}</div>
                                <div class="text-grey-darkest mb-2">
                                    {{ invitation.officeStreetNumber }} {{ invitation.officeStreetName }}<br />
                                    {{ invitation.officeZipCode }} {{ invitation.officeLocality }}
                                </div>
                            </div>
                        </div>
                        <gmap-map
                            :center="{lat: invitation.officeLocation._lat, lng: invitation.officeLocation._long }"
                            :zoom="12"
                            :options="{disableDefaultUI: true}"
                            style="height: 250px;"
                            class="w-full">
                                <gmap-marker
                                    :position="{lat: invitation.officeLocation._lat, lng: invitation.officeLocation._long }"></gmap-marker>
                            </gmap-map>
                        <button @click.prevent="accept" class="inline-block w-full px-6 py-4 bg-blue hover:bg-blue-dark text-center rounded-b">
                            <span class="text-sm text-white font-semibold uppercase tracking-wide w-full px-2 py-3">{{ $t('Accept_this_appointment_invitation') }}</span>
                        </button>
                    </div>
                    <div class="text-center mt-3">
                        <button @click.prevent="showDecline" class="text-xs hover:underline text-grey font-semibold uppercase tracking-wide px-1 py-1">{{ $t('Decline') }}</button>
                    </div>
                </div>
                <div v-if="step == 'submitting'">
                    <div class="rounded bg-white shadow relative -mt-24">
                        <div class="flex items-center justify-center h-64">
                            <div class="text-center">
                                <span class="icon text-5xl text-grey"><i class="mdi mdi-loading mdi-spin"></i></span><br />
                                <span class="text-sm text-grey-darker mt-4">{{ $t('Loading') }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="step == 'submitted'">
                    <div class="rounded bg-white shadow relative -mt-24">
                        <router-link :to="{ path: '/' }" class="text-green-lighter hover:text-green-lightest text-xl absolute pin-t pin-r p-2 m-2">
                            <span class="icon"><i class="mdi mdi-close"></i></span>
                        </router-link>
                        <div class="flex items-center justify-center bg-green text-white rounded px-4 py-10 w-full">
                            <span class="icon text-5xl text-white"><i class="mdi mdi-verified"></i></span>
                            <span class="text-sm text-xl ml-4">{{ $t('Appointment_confirmed') }}</span>
                        </div>
                    </div>
                </div>
                <div v-if="step == 'submittedDeclination'">
                    <div class="rounded bg-white shadow relative -mt-24">
                        <router-link :to="{ path: '/' }" class="text-green-lighter hover:text-green-lightest text-xl absolute pin-t pin-r p-2 m-2">
                            <span class="icon"><i class="mdi mdi-close"></i></span>
                        </router-link>
                        <div class="flex items-center justify-center bg-green text-white rounded px-4 py-10 w-full">
                            <span class="icon text-5xl text-white"><i class="mdi mdi-verified"></i></span>
                            <span class="text-sm text-xl ml-4">{{ $t('Appointment_declined') }}</span>
                        </div>
                    </div>
                </div>
                <div v-if="step == 'submissionError'">
                    <div class="rounded bg-white shadow relative -mt-24">
                        <router-link :to="{ path: '/' }" class="text-red-lighter hover:text-red-lightest text-xl absolute pin-t pin-r p-2 m-2">
                            <span class="icon"><i class="mdi mdi-close"></i></span>
                        </router-link>
                        <div class="flex items-center justify-center bg-red text-white rounded px-4 py-10 w-full">
                            <span class="icon text-5xl text-white"><i class="mdi mdi-alert-circle"></i></span>
                            <span class="text-sm text-xl ml-4" v-text="errorText ? errorText : $t('an_error_occured')"></span>
                        </div>
                    </div>
                </div>
                <div class="mt-3 text-sm text-center text-grey-dark" v-if="step == 'submitted' || step == 'submittedDeclination'">{{ $t('Redirecting') }}</div>
                <dfp-slot
                    v-if="invitation"
                    path="/21865209613/Patients/InvitationShow"
                    :size="[300,250]"
                    :id="`div-gpt-ad-partner-invitation`"
                    :medical-practice="invitation.emergencyType"
                    class="mt-6" />
            </div>
        </section>
        <decline-invitation-modal :active="showDeclineModal" :invitation="invitation" @close="hideDecline" @declined="decline"></decline-invitation-modal>
    </div>
</template>

<script>
import firebase from 'firebase/app'
import helpers from '@/mixins/helpers'

import HeaderNav from '@/components/Patient/HeaderNav'
import DeclineInvitationModal from '@/components/Patient/DeclineInvitationModal'

import appointmentInvitationRepository from '@/data/AppointmentInvitationRepository'

export default {
    name: 'InvitationShow',

    mixins: [helpers],

    components: {HeaderNav, DeclineInvitationModal},

    data () {
        return {
            step: 'invitationDetails',
            invitation: null,
            showDeclineModal: false,
            errorText: false
        }
    },

    mounted () {
        this.fetchInvitation()
    },

    methods: {
        showDecline () {
            this.showDeclineModal = true
        },

        hideDecline () {
            this.showDeclineModal = false
        },

        fetchInvitation () {
            this.setLoading(true)

            let invitationId = this.$route.params.id

            appointmentInvitationRepository.find(invitationId, (invitation) => {
                if (invitation.patientId != this.userId) {
                    throw new Error(this.$t('Errors.appointment_invitation_could_not_be_loaded'))
                }

                if (invitation.appointmentId) {
                    throw new Error(this.$t('Errors.appointment_invitation_already_accepted'))
                }

                if (invitation.hasBeenCancelled || invitation.hasBeenAutoCancelled) {
                    throw new Error(this.$t('Errors.appointment_invitation_cancelled'))
                }

                if (invitation.hasBeenDeclined) {
                    throw new Error(this.$t('Errors.appointment_invitation_declined'))
                }

                this.invitation = invitation

                if (this.$route.params.decline == true) {
                    this.showDecline()
                }
            }, (error) => {
                this.changeStep('submissionError')
                this.errorText = error.message
            })
        },

        changeStep (step) {
            if (step != 'submissionError') {
                this.errorText = false
            }

            this.step = step
            window.scrollTo(0, 0)
        },

        accept () {
            this.changeStep('submitting')

            appointmentInvitationRepository.acceptByPatient(this.invitation, (id) => {
                this.changeStep('submitted')

                this.$ga.event({
                    eventCategory: 'AppointmentInvitations',
                    eventAction: 'AcceptAppointmentInvitations'
                })

                setTimeout(() => {
                    this.$router.push({
                        name: 'appointment.show',
                        params: {
                            id: id
                        }
                    })
                }, 3000)
            }, (error) => {
                this.errorText = error.message
                this.changeStep('submissionError')
            })
        },

        decline () {
            this.hideDecline()
            this.changeStep('submitting')

            appointmentInvitationRepository.declineByPatient(this.invitation, () => {
                this.changeStep('submittedDeclination')

                this.$ga.event({
                    eventCategory: 'AppointmentInvitations',
                    eventAction: 'DeclineAppointmentInvitations'
                })

                setTimeout(() => {
                    this.$router.push("/")
                }, 3000)
            }, (error) => {
                console.log('error', error)
                this.errorText = error.message
                this.changeStep('submissionError')
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Patient/InvitationShow.vue